import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { useAuthContext } from "@hooks/useAuthContext";

interface PrivateRouteProps {
    children: ReactNode
}

export function PrivateRoute(props: PrivateRouteProps) {
    const { children } = props;
    const { isUserAuthenticated } = useAuthContext();

    if (!isUserAuthenticated) {
        return <Navigate to="/" replace />;
    }

    return children;
}